import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { Form } from 'react-bootstrap'
import Loader from '../../loader/Loader'
import Text from '../../input_filed/Text'
import File from '../../input_filed/File'
import SingleSelect from '../../input_filed/SingleSelect'
import SaveButton from '../../buttons/SaveButton'
import { ToastContainer, toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import { PopupDetailsRes, PopupDetailsTodo } from '../../../redux/slices/popup/PopupDetails'
import { PopupSchema } from './Validation'
import { UpdatePopupRes, UpdatePopupTodo } from '../../../redux/slices/popup/UpdatePopup'


export default function UpdatePopupForm() {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const { state } = useLocation()
    const PopupData = useSelector(state => state?.PopupDetails?.data?.data)


    const initialValues = {
        id: PopupData?.id,
        name: PopupData?.popup_name,
        img: PopupData?.popup_image,
        type: PopupData?.popup_type,
    }

    const type_option = [
        { "value": 'vendor', "label": "Vendor" },
        { "value": 'customer', "label": "Customer" },
        { "value": 'both', "label": "Both" },
    ]

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: PopupSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(UpdatePopupTodo(bodyFormData)).then(() => add_res(action))
        }
    })

    let bodyFormData = new FormData();
    bodyFormData.append("user_id", localStorage.getItem('user_id'))
    bodyFormData.append("popup_id", values.id)
    bodyFormData.append("popup_name", values.name)
    bodyFormData.append("popup_image", values.img)
    bodyFormData.append("popup_type", values.type)

    const add_res = (action) => {
        if (UpdatePopupRes?.success) {
            toast.success(UpdatePopupRes?.message, { position: "bottom-right" });
            setLoading(false)
            setTimeout(() => {
                navigate('/popup')
            }, 1500);
        } else {
            toast.error(UpdatePopupRes?.message, { position: "bottom-right" });
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(PopupDetailsTodo(state)).then(() => details_res())
    }, [])
    const details_res = () => {
        if (PopupDetailsRes?.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }


    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <div className='form_layout mt-3'>
                    {loading ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :
                        <div className='row'>
                            <div className='col-md-4 '>
                                <Text
                                    label_name='Name'
                                    placeholder=''
                                    name='name'
                                    value={values.name || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name && touched.name ? (<span className='text-danger form_label' >{errors.name}</span>) : null}
                                />
                            </div>
                            <div className='col-md-4  mb-2 '>
                                <File
                                    name='img'
                                    label_name={'Image'}
                                    onBlur={handleBlur}
                                    onChange={(e) => setFieldValue("img", e.currentTarget.files[0])}
                                    error={errors.img && touched.img ? (<span className='text-danger form_label' >{errors.img}</span>) : null}
                                />
                                {/* <p></p> */}

                            </div>
                            <div className='col-md-4  mb-2'>
                                <SingleSelect
                                    closeMenu={true}
                                    label_name='Type'
                                    disabled={false}
                                    option={type_option ? type_option : []}
                                    name='type'
                                    defaultValue={type_option && type_option.find((option) => option.value === values.type)}
                                    onChange={(e) =>
                                        setFieldValue('type', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.type && touched.type ? (<span className='text-danger form_label' >{errors.type}</span>) : null}
                                />
                            </div>


                            <div className='col-md-12 text-end mt-2'>
                                <SaveButton name={'Update'} />
                            </div>
                        </div>}
                </div>
            </Form>
            <ToastContainer />
        </>
    )
}
